import { Button, InputLabel, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

import { useDisclosure } from '@hooks/useDisclosure';
import Flex from '@Components/Bases/Flex';
import NetZeroTable from './NetZeroTable/NetZeroTable';
import ModalNetZero from './ModalNetZero/ModalNetZero';
import { useGreenhouseGoalTerm } from '../GreenhouseGoalTermProvider/GreenhouseGoalTermProvider';
import { useWatch } from 'react-hook-form';
import { INetZeroDetailFormValues } from '../../EsgGreenhouseFormProvider/types';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';

const NetZeroDetail = () => {
  const { ghGasScope } = useGreenhouseGoalTerm();
  const {
    formState: { errors },
  } = useGreenhouseForm();

  const [opened, { open, close }] = useDisclosure();

  const [netZeroDetails, completedSection] = useWatch({
    name: [
      'greenhouseGoalTerm.netZero.details',
      'greenhouseGoalTerm.completedSection',
    ],
  }) as [INetZeroDetailFormValues[] | undefined, CompleteSectionFormValues];

  const prevScopeIds = netZeroDetails?.map((detail) => detail.scopeId);
  const scopeExists = ghGasScope?.filter(
    (option) => !prevScopeIds?.includes(option.id)
  );

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};
  const netZeroError = errors.greenhouseGoalTerm?.netZero?.details;

  return (
    <>
      <Flex justifyContent={'space-between'} alignItems={'center'} my={2}>
        <InputLabel required sx={{ fontWeight: 'bold' }}>
          รายละเอียดการตั้งเป้าหมายการปล่อยก๊าซเรือนกระจกสุทธิเป็นศูนย์
          (Net-Zero Greenhouse Gas Emissions)
        </InputLabel>
        <Button
          color={'inherit'}
          startIcon={<Add />}
          onClick={open}
          disabled={scopeExists?.length === 0 || isCompletedTh || isCompletedEn}
        >
          เพิ่มข้อมูล
        </Button>
      </Flex>
      <NetZeroTable />
      {netZeroError && (
        <Typography mt={2} variant={'caption'} color={'error.main'}>
          {netZeroError.message}
        </Typography>
      )}
      <ModalNetZero mode="create" open={opened} close={close} />
    </>
  );
};

export default NetZeroDetail;
